/* eslint-disable global-require */
export const navLinks = ['', 'phones', 'tablets', 'accessories'];

export const categoriesWithInput = ['phones', 'favourites'];

export const categoriesPath = ['phones', 'tablets', 'accessories'];

export const footerLinks = [
  ['https://github.com/petrovskyi-yevhen', 'Github'],
  ['https://t.me/petrovskyi_e', 'Telegram'],
  ['https://www.linkedin.com/in/yevhen-petrovskyi/', 'Linkedin'],
];

export const categoryImages = [
  require('../assets/categories/category-phones.png'),
  require('../assets/categories/category-tablets.png'),
  require('../assets/categories/category-accessories.png'),
];

export const pageNotFoundImage = [require('../assets/others/not-found.png')][0];

export const pageComingSoonImage = [
  require('../assets/others/coming-soon.png'),
][0];

export const favouritesPageImage = [
  require('../assets/others/favourites.png'),
][0];

export const checkoutPageImage = [
  require('../assets/others/shopping-cart-done.png'),
][0];

export const cartPageImage = [require('../assets/others/shopping-cart.gif')][0];

export const wentWrong = [require('../assets/others/went-wrong.png')][0];

export const carouselImages = [
  require('../assets/banners/banner-phones.png'),
  require('../assets/banners/banner-tablets.png'),
  require('../assets/banners/banner-accessories.png'),
];
